<div class="mass-os-table">
  <div class="mass-os-table__toolbar">
    <div class="mass-os-table__hint">
      <mat-icon>info</mat-icon>
      <div>
        <span>
          Genera <strong>OS</strong> (fecha de pago programada) u
          <strong>OP</strong> solo en Alimentos (fecha de revisión).
        </span>
        <div class="mass-os-table__legend" aria-hidden="true">
          <span class="mass-os-table__legend-item mass-os-table__legend-item--os"
            >Bloque OS</span
          >
          <span class="mass-os-table__legend-item mass-os-table__legend-item--op"
            >Bloque OP</span
          >
        </div>
      </div>
    </div>

    <div class="mass-os-table__cta-group">
      <button
        mat-flat-button
        color="primary"
        type="button"
        class="mass-os-table__cta"
        [disabled]="selectedForOsCount === 0 || isBusy"
        (click)="generateOrders.emit()"
      >
        <mat-icon *ngIf="!isCreateOrderBusy">receipt_long</mat-icon>
        <mat-spinner *ngIf="isCreateOrderBusy" [diameter]="18"></mat-spinner>
        <span>{{ isCreateOrderBusy ? 'Creando OS…' : 'Generar OS' }}</span>
        <span class="mass-os-table__cta-count" *ngIf="selectedForOsCount > 0">
          {{ selectedForOsCount }}
        </span>
      </button>

      <button
        mat-stroked-button
        type="button"
        class="mass-os-table__cta mass-os-table__cta--np"
        [disabled]="selectedForNpCount === 0 || isBusy"
        (click)="generatePurchaseNotes.emit()"
      >
        <mat-icon *ngIf="!isCreatePurchaseNoteBusy">restaurant</mat-icon>
        <mat-spinner
          *ngIf="isCreatePurchaseNoteBusy"
          [diameter]="18"
        ></mat-spinner>
        <span>{{ isCreatePurchaseNoteBusy ? 'Creando OP…' : 'Generar OP' }}</span>
        <span class="mass-os-table__cta-count" *ngIf="selectedForNpCount > 0">
          {{ selectedForNpCount }}
        </span>
      </button>
    </div>
  </div>

  <div class="mass-os-table__empty" *ngIf="!isLoading && !dataSource?.data?.length">
    <mat-icon>inbox</mat-icon>
    <p>No hay servicios para mostrar con los filtros actuales.</p>
  </div>

  <div class="mass-os-table__scroll" *ngIf="dataSource?.data?.length">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      multiTemplateDataRows
      class="mass-os-mat-table"
    >
      <ng-container matColumnDef="Check">
        <th mat-header-cell *matHeaderCellDef class="mass-os-col--check">
          <mat-checkbox
            (change)="$event ? toggleAllRows() : null"
            [checked]="isAllSelected()"
            [disabled]="isBusy"
          ></mat-checkbox>
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="mass-os-col--check"
          (click)="$event.stopPropagation()"
        >
          <mat-checkbox
            [checked]="row.checked"
            [disabled]="!isRowSelectable(row) || isBusy"
            (change)="updateCheck(row)"
          ></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="serviceDay">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="serviceDay"
          class="mass-os-col--day"
        >
          {{ headers.serviceDay }}
        </th>
        <td mat-cell *matCellDef="let row" class="mass-os-col--day">
          {{ row.day }}
        </td>
      </ng-container>

      <ng-container matColumnDef="fecha">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="fecha"
          class="mass-os-col--date"
        >
          {{ headers.fecha }}
        </th>
        <td mat-cell *matCellDef="let row" class="mass-os-col--date">
          {{ serviceDate(row) ? (serviceDate(row) | date: 'dd/MM/yyyy') : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="tipoServicio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="mass-os-col--tipo">
          {{ headers.tipoServicio }}
        </th>
        <td mat-cell *matCellDef="let row" class="mass-os-col--tipo">
          <span
            class="mass-os-tipo-chip"
            [matTooltip]="row.tipoServicio || ''"
            >{{ row.tipoServicio || '-' }}</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="nombreServicio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="mass-os-col--text">
          {{ headers.nombreServicio }}
        </th>
        <td mat-cell *matCellDef="let row" class="mass-os-col--text">
          <span
            class="mass-os-cell-text"
            [matTooltip]="row.nombreServicio || ''"
            >{{ row.nombreServicio || '-' }}</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="nombre">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="nombre"
          class="mass-os-col--text"
        >
          {{ headers.nombre }}
        </th>
        <td mat-cell *matCellDef="let row" class="mass-os-col--text">
          <span
            class="mass-os-cell-text"
            [matTooltip]="row.providerSnapshot?.nombre || ''"
            >{{ row.providerSnapshot?.nombre || '-' }}</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="moneda">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="mass-os-col--moneda">
          {{ headers.moneda }}
        </th>
        <td mat-cell *matCellDef="let row" class="mass-os-col--moneda">
          {{ row.moneda || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="pax">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="pax"
          class="mass-os-col--pax"
        >
          {{ headers.pax }}
        </th>
        <td mat-cell *matCellDef="let row" class="mass-os-col--pax">
          {{ row.paxQuantity ?? 0 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="costo">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="costo"
          class="mass-os-col--money"
        >
          {{ headers.costo }}
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="mass-os-col--money"
          (click)="$event.stopPropagation()"
        >
          <div class="mass-os-cell__inner mass-os-cell__inner--end">
            <span>{{ serviceAmount(row) }}</span>
            <button
              mat-icon-button
              type="button"
              *ngIf="canEditAmount(row)"
              matTooltip="Editar monto"
              (click)="editTarifa.emit(row)"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="orderNumber">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="orderNumber"
          class="mass-os-col--doc mass-os-col--os"
        >
          {{ headers.orderNumber }}
        </th>
        <td mat-cell *matCellDef="let row" class="mass-os-col--doc mass-os-col--os">
          <ng-container *ngIf="isTicketRow(row); else orderNumberNormal">
            <span
              class="mass-os-ticket-hint"
              matTooltip="OS por ticket — expandir fila"
              >Ver expand</span
            >
          </ng-container>
          <ng-template #orderNumberNormal>
            {{ row.order?.displayCode || row.order?.orderNumber || '-' }}
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="orderStatus">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="orderStatus"
          class="mass-os-col--status mass-os-col--os"
        >
          {{ headers.orderStatus }}
        </th>
        <td mat-cell *matCellDef="let row" class="mass-os-col--status mass-os-col--os">
          <ng-container *ngIf="isTicketRow(row); else orderStatusNormal">
            <span
              class="mass-os-ticket-hint"
              matTooltip="OS por ticket — expandir fila"
              >Ver expand</span
            >
          </ng-container>
          <ng-template #orderStatusNormal>
            <span
              class="os-status"
              [attr.data-os-status]="row.order.orderStatus.toUpperCase()"
              *ngIf="row.order?.orderStatus; else noStatus"
            >
              {{ row.order.orderStatus }}
            </span>
            <ng-template #noStatus>-</ng-template>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="freezeDeadlineAt">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="mass-os-col--date mass-os-col--os"
        >
          {{ headers.freezeDeadlineAt }}
        </th>
        <td mat-cell *matCellDef="let row" class="mass-os-col--date mass-os-col--os">
          <ng-container *ngIf="isTicketRow(row); else corteNormal">
            <span class="mass-os-ticket-hint">—</span>
          </ng-container>
          <ng-template #corteNormal>
            {{
              row.order?.freezeDeadlineAt
                ? (row.order.freezeDeadlineAt | customDate | date: "dd/MM/yyyy")
                : "-"
            }}
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="scheduledPaymentDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="scheduledPaymentDate"
          class="mass-os-col--date mass-os-col--os"
        >
          {{ headers.scheduledPaymentDate }}
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="mass-os-col--date mass-os-col--os"
          (click)="$event.stopPropagation()"
        >
          <ng-container *ngIf="isTicketRow(row); else scheduledNormal">
            <span class="mass-os-ticket-hint">—</span>
          </ng-container>
          <ng-template #scheduledNormal>
            <div class="mass-os-cell__inner mass-os-cell__inner--center">
              <span>
                {{
                  row.order?.scheduledPaymentDate
                    ? (row.order?.scheduledPaymentDate
                      | customDate
                      | date: 'dd/MM/yyyy')
                    : '-'
                }}
              </span>
              <button
                mat-icon-button
                type="button"
                *ngIf="!(row.ssffproduct && row.productId) && isOrderEditable(row)"
                matTooltip="Editar fecha de pago programada"
                (click)="editPaymentDate.emit(row)"
              >
                <i-tabler name="calendar-repeat" class="icon-18"></i-tabler>
              </button>
            </div>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="paidAt">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="paidAt"
          class="mass-os-col--date mass-os-col--os"
        >
          {{ headers.paidAt }}
        </th>
        <td mat-cell *matCellDef="let row" class="mass-os-col--date mass-os-col--os">
          <ng-container *ngIf="isTicketRow(row); else paidAtNormal">
            <span class="mass-os-ticket-hint">—</span>
          </ng-container>
          <ng-template #paidAtNormal>
            {{
              row.order?.paidAt?.includes('T')
                ? (row.order?.paidAt | date: 'dd/MM/yyyy')
                : (row.order?.paidAt || '-')
            }}
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="purchaseNoteNumber">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="purchaseNoteNumber"
          class="mass-os-col--doc mass-os-col--op"
        >
          {{ headers.purchaseNoteNumber }}
        </th>
        <td mat-cell *matCellDef="let row" class="mass-os-col--doc mass-os-col--op">
          {{ row.purchaseNote?.purchaseNoteNumber || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="purchaseNoteStatus">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="purchaseNoteStatus"
          class="mass-os-col--status mass-os-col--op"
        >
          {{ headers.purchaseNoteStatus }}
        </th>
        <td mat-cell *matCellDef="let row" class="mass-os-col--status mass-os-col--op">
          <span
            class="os-status"
            [attr.data-os-status]="
              row.purchaseNote.purchaseNoteStatus.toUpperCase()
            "
            *ngIf="row.purchaseNote?.purchaseNoteStatus; else noNpStatus"
          >
            {{ row.purchaseNote.purchaseNoteStatus }}
          </span>
          <ng-template #noNpStatus>-</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="purchaseNoteReviewDate">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="purchaseNoteReviewDate"
          class="mass-os-col--date mass-os-col--op"
        >
          {{ headers.purchaseNoteReviewDate }}
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="mass-os-col--date mass-os-col--op"
          (click)="$event.stopPropagation()"
        >
          <div class="mass-os-cell__inner mass-os-cell__inner--center">
            <span>
              {{
                row.purchaseNote?.reviewDate
                  ? (row.purchaseNote?.reviewDate | customDate | date: 'dd/MM/yyyy')
                  : '-'
              }}
            </span>
            <button
              mat-icon-button
              type="button"
              *ngIf="
                !(row.ssffproduct && row.productId) && isPurchaseNoteEditable(row)
              "
              matTooltip="Editar fecha de revisión"
              (click)="editReviewDate.emit(row)"
            >
              <i-tabler name="calendar-repeat" class="icon-18"></i-tabler>
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="verPDF">
        <th mat-header-cell *matHeaderCellDef class="mass-os-col--actions">
          {{ headers.verPDF }}
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="mass-os-col--actions"
          (click)="$event.stopPropagation()"
        >
          <div class="mass-os-actions-inner">
            <ng-container *ngIf="isTicketRow(row); else actionsNormal">
              <span
                class="mass-os-ticket-hint"
                matTooltip="Acciones OS por ticket — expandir fila"
                >Ver expand</span
              >
            </ng-container>
            <ng-template #actionsNormal>
              <app-services-os-actions
                [row]="row"
                [model]="model"
                [showPurchaseNotePdf]="true"
                (modelChanged)="modelChanged.emit()"
              ></app-services-os-actions>
            </ng-template>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="expand">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="mass-os-col--expand"
          aria-label="expand row"
        >
          &nbsp;
        </th>
        <td mat-cell *matCellDef="let row" class="mass-os-col--expand">
          <button
            *ngIf="isTicketRow(row)"
            mat-icon-button
            type="button"
            aria-label="expand row"
            (click)="toggleExpandRow(row, $event)"
          >
            <mat-icon>{{
              isRowExpanded(row) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
            }}</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="displayedColumns.length"
        >
          <div
            class="mass-os-ticket-expand"
            [@detailExpand]="isRowExpanded(element) ? 'expanded' : 'collapsed'"
          >
            <ng-container *ngIf="isTicketRow(element) && isRowExpanded(element)">
              <div
                *ngIf="element.ticketsLoading"
                class="mass-os-ticket-expand__loading"
              >
                <mat-progress-spinner
                  mode="indeterminate"
                  diameter="28"
                ></mat-progress-spinner>
                <span>Cargando tickets…</span>
              </div>
              <app-table-expand
                *ngIf="element.ticketsLoaded && !element.ticketsLoading"
                [file]="element"
                [data]="element.tickets || []"
                [allData]="model"
                [viewOnly]="true"
                [allowTicketSelect]="true"
                [isParentFile]="isSSFF"
                (selectionChange)="onTicketSelectionChange($event)"
                (ticketsOrderChanged)="onTicketsOrderChanged($event)"
              ></app-table-expand>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="mass-os-row"
        [class.mass-os-row--expandable]="isTicketRow(row)"
        [class.mass-os-row--expanded]="isRowExpanded(row)"
        (click)="isTicketRow(row) ? toggleExpandRow(row) : null"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="mass-os-detail-row"
      ></tr>
    </table>
  </div>

  <mat-paginator
    *ngIf="dataSource?.data?.length"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 25, 100]"
  ></mat-paginator>
</div>
